export const pageTitle = (title) => {
  return ( document.title = title + " - Personal Portfolio React Template");
}